import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface GameSectionProps {
  title: string;
  viewAllLink?: string;
  viewAllText?: string;
  headerRight?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
}

export function GameSection({
  title,
  viewAllLink,
  viewAllText = 'View all',
  headerRight,
  className,
  children
}: GameSectionProps) {
  return (
    <section className={cn('bg-white dark:bg-gray-800 rounded-2xl p-3 md:p-3 xl:p-4 shadow-sm', className)}>
      <div className="flex items-center justify-between mb-3 md:mb-2 xl:mb-4">
        <h2 className="font-bebas-neue text-xl md:text-2xl xl:text-[clamp(20px,1.5vw,28px)] tracking-[2px] uppercase">
          {title}
        </h2>

        {headerRight ?? (viewAllLink && (
          <Link
            to={viewAllLink}
            className="font-oswald text-sm font-medium text-muted-foreground uppercase tracking-[1px] transition-colors hover:text-foreground"
          >
            {viewAllText}
          </Link>
        ))}
      </div>
      
      {children}
    </section>
  );
}